import { Address } from '@pelicargo/types';
import { FreightService } from '@prisma/client';
import { useMemo } from 'react';

// Used for getting the zip, but only when uncertified
export const useZipOrigin = (freightService: FreightService, cargoOrigin: Address) => {
  const zipOrigin = useMemo(() => {
    if (freightService === FreightService.EXW && cargoOrigin?.zip_code) {
      return cargoOrigin?.zip_code;
    }
  }, [cargoOrigin, freightService]);
  return zipOrigin;
};
